import type { PrintPayloadOptions, PrintPayloadStrategy, PrintReceiptSource } from './types'
import { buildBasePayload } from './buildBasePayload'
import { displayDiscountBillText, deriveVatText } from './derive/labels'

/**
 * Printer interface < 3.20 (the 3.14-era installs) — routes `/printPayment` and
 * `/printPreview`, plain `Receipt` model. The renderer computes the summary
 * itself from the numeric fields, so those must be present and correct:
 * SubTotal, Discount, DiscountText, Vat, VatText, VatValue, ServiceCharge(+Text),
 * CardCharge(+Text), Rounding, GrandTotal, Date, Note, DiscountRequest.
 *
 * It does NOT read Summary1..4, so none are emitted.
 */
export const PrintPayloadStrategyLegacy: PrintPayloadStrategy = {
  key: 'legacy',
  usesSummarySections: false,

  build(source: PrintReceiptSource, options: PrintPayloadOptions): Record<string, any> {
    const payload = buildBasePayload(source, options)

    payload.VatText = deriveVatText(source)
    payload.DiscountText = displayDiscountBillText(
      source?.DiscountRequest?.mode,
      source?.DiscountRequest?.value,
    )

    // The legacy renderer draws its own rounding line from the numeric fields and
    // would double-count the plug. Zeroed on this path only — preserved from the
    // previous `options.isPrinterInterfaceV3 === false` branch.
    payload.Rounding = 0

    delete payload.Summary1
    delete payload.Summary2
    delete payload.Summary3
    delete payload.Summary4

    return payload
  },
}
